import { rd } from '@passionware/monads';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { resourceQueryUtils } from 'v5/api/resource/resource.api';
import { rowLevelValidation } from 'v5/platform/row-level-validation';
import { myServices } from 'v5/services/services.connected.app';
import { selectAccountsList } from '../../../store/accounts';
import { parseInitials } from '../../../v1/helpers/misc';
import { createUserPicker, UserPickerConfig } from './UserPicker';

export const ownerPickerConfig: UserPickerConfig = {
  useUsers: query => {
    const allUsers = useSelector(selectAccountsList);
    const matchingUsers = useMemo(
      () =>
        allUsers
          .filter(u => !u.dateArchived)
          .filter(u =>
            u.displayName.toLowerCase().includes(query.toLowerCase())
          )
          .map(u => ({
            id: u.id,
            profileImage: u.profileImage,
            name: u.displayName,
            initials: parseInitials(
              u.firstName,
              u.lastName,
              u.displayName
            ).slice(0, 2)
          })),
      [allUsers, query]
    );
    return matchingUsers;
  },
  usePlaceholder: () => 'Change owner to…'
};
export const ConnectedOwnerPicker = createUserPicker(ownerPickerConfig);

export const ResourcePicker = createUserPicker({
  useUsers: query => {
    const resources = rd.useLastWithPlaceholder(
      myServices.resourceService.useList(
        resourceQueryUtils
          .getBuilder()
          .build(q => [
            q.withSearch(query),
            q.withFilter('archived', { operator: 'equal', value: false })
          ])
      )
    );
    const matchingUsers = rd.mapOrElse(
      resources,
      resources =>
        rowLevelValidation.validDataFromRows(resources.items).map(r => ({
          id: String(r.id),
          profileImage: r.profile_picture,
          name: r.full_name,
          initials: parseInitials(r.first_name, r.last_name, r.full_name).slice(
            0,
            2
          )
        })),
      []
    );
    return matchingUsers;
  },
  usePlaceholder: () => 'Change owner to…'
});
